import ApplicationRoutes from "./ApplicationRoutes";

export default function AppRoutes() {
  return <ApplicationRoutes />;
}
